export default class Popup {
    static init() {
        if (document.body.classList.contains('neos-backend')) {
            return;
        }

        document.addEventListener('DOMContentLoaded', function () {
            document.body.addEventListener('click', function (event) {
                const closestOpenPopup = event.target.closest('.open-popup');
                if (closestOpenPopup) {
                    const popupId = closestOpenPopup.getAttribute('data-popup-id');
                    const popup = document.getElementById(popupId);
                    Popup.createAndAttachOverlay();
                    document.body.classList.add('noscroll');
                    popup.classList.add('active');
                }

                if (event.target.closest('.close-popup') || event.target.closest('.popup-overlay')) {
                    const popups = document.querySelectorAll('.popup');
                    popups.forEach(function (popup) {
                        popup.classList.remove('active');
                    });
                    document.body.classList.remove('noscroll');
                    Popup.destroyOverlay();
                }
            });
        });
    }

    static createAndAttachOverlay() {
        const overlay = document.createElement('div');
        overlay.id = 'popup-overlay';
        overlay.classList.add('popup-overlay');
        document.body.appendChild(overlay);
        return overlay;
    }

    static destroyOverlay() {
        const overlay = document.getElementById('popup-overlay');
        overlay.remove();
    }
}
